<script>
import { v4 as uuid } from "uuid";
import { childAges } from "../../../Constants";
import { clickOutside } from "../../../Helpers/directives";

// select html tag
const root = document.getElementsByTagName("html")[0];

export default {
  name: "Travelers",

  props: {
    value: {
      type: Object,
      required: null,
      default: null,
    },
    maxRooms: {
      type: Number,
      default: 4,
      required: false,
    },
    maxAdultsPerRoom: {
      type: Number,
      default: 4,
      required: false,
    },
    maxChildrenPerRoom: {
      type: Number,
      default: 4,
      required: false,
    },
  },

  data() {
    return {
      childAges,
      isOpen: false,
      error: null,
      rooms: [
        {
          adults: 2,
          children: [],
          key: uuid(),
        },
      ],
    };
  },

  computed: {
    roomsCount() {
      return this.rooms.length;
    },

    adultsCount() {
      return this.rooms.reduce((total, room) => total + room.adults, 0);
    },

    childrenCount() {
      return this.rooms.reduce((total, room) => total + room.children.length, 0);
    },

    totalPassengerCount() {
      return this.adultsCount + this.childrenCount;
    },

    isValid() {
      return !this.error;
    },
  },

  methods: {
    handleShowList() {
      if (this.isOpen) {
        this.isOpen = false;
      } else {
        if (window.innerWidth < 993) {
          root.classList.add("no-scroll");
        }

        this.isOpen = true;
      }
    },

    addRoom() {
      if (this.roomsCount < this.maxRooms) {
        this.rooms.push({
          adults: 1,
          children: [],
          key: uuid(),
        });
      }
    },

    roomDelete(room) {
      const index = this.rooms.findIndex((item) => item.key === room.key);
      if (index >= 0) this.rooms.splice(index, 1);
    },

    updateAdults(roomIndex, increment) {
      const room = this.rooms[roomIndex];
      if (increment && room.adults < this.maxAdultsPerRoom) {
        room.adults++;
      } else if (!increment && room.adults > 1) {
        room.adults--;
      }
    },

    updateChildren(roomIndex, increment) {
      const room = this.rooms[roomIndex];
      if (increment && room.children.length < this.maxChildrenPerRoom) {
        room.children.push({ value: 0 });
      } else if (!increment && room.children.length > 0) {
        room.children.pop();
      }
    },

    setChildeAge(roomIndex, childIndex, event) {
      this.rooms[roomIndex].children[childIndex].value = Number(event.target.value);
    },

    closeTravelerList(e) {
      if (this.isOpen && !e.target.classList.contains("js-room-delete")) {
        this.isOpen = false;

        if (window.innerWidth < 993) {
          root.classList.remove("no-scroll");
        }
      }
    },

    validate() {
      this.error = null;

      this.error = this.rooms.length ? null : "حداقل یک اتاق باید وجود داشته باشد";
    },
  },

  watch: {
    rooms: {
      handler(newValue) {
        this.$emit("input", newValue);
        this.validate();
      },
      deep: true,
    },
  },

  mounted() {
    this.$emit("input", this.rooms);
  },

  directives: {
    "click-outside": clickOutside,
  },
};
</script>

<template>
  <div :class="['booking__item w-100 fa-font', isOpen && 'is-open']" v-click-outside="closeTravelerList">
    <div :class="['booking__input', error && 'is-invalid']" @click="handleShowList">
      <label class="booking__input-label">مسافران و اتاق</label>

      <span class="booking__input-value">{{ totalPassengerCount }} مسافر . {{ roomsCount }} اتاق</span>
    </div>

    <label v-if="error" class="booking__item-validation">{{ error }}</label>

    <div class="booking__passengers" v-if="isOpen">
      <div class="booking__item-header hide-in-desktop">
        <span> مسافران و اتاق </span>

        <button class="icon-close" @click="closeTravelerList" />
      </div>

      <div class="booking__passengers-inner">
        <div class="booking__room custom-scroll-bar">
          <div class="booking__passengers-select" v-for="(room, index) in rooms" :key="room.key">
            <div class="booking__passengers-select-header">
              <span class="bold"> اتاق {{ index + 1 }} </span>

              <button
                class="js-room-delete icon-bin"
                v-if="rooms.length > 1"
                @click="roomDelete(room)"
                title="حذف اتاق"
              />
            </div>

            <ul class="booking__passengers-rows">
              <li class="booking__passengers-row">
                <div class="booking__passengers-row-title">
                  <span>بزرگسال</span>

                  <label>(12 سال به بالا)</label>
                </div>

                <div class="booking__counter">
                  <button class="btn btn-counter icon-plus" @click="updateAdults(index, true)" />

                  <span class="bold">
                    {{ room.adults }}
                  </span>

                  <button class="btn btn-counter icon-min" @click="updateAdults(index, false)" />
                </div>
              </li>

              <li class="booking__passengers-row">
                <div class="booking__passengers-row-title">
                  <span>کودک</span>
                </div>

                <div class="booking__counter">
                  <button class="btn btn-counter icon-plus" @click="updateChildren(index, true)" />

                  <span>
                    {{ room.children.length }}
                  </span>

                  <button class="btn btn-counter icon-min" @click="updateChildren(index, false)" />
                </div>
              </li>
            </ul>

            <ul class="booking__passengers-items" v-if="room.children.length">
              <li v-for="(child, index) in room.children" :key="index">
                <span> سن کودک {{ room.children.indexOf(child) + 1 }} </span>

                <select @change="setChildeAge(rooms.indexOf(room), room.children.indexOf(child), $event)">
                  <option v-for="childAge in childAges" :key="childAge.value" :value="childAge.value">
                    {{ childAge.title }}
                  </option>
                </select>
              </li>
            </ul>
          </div>
        </div>

        <div class="px--2 py--1 booking__room-add-room">
          <button class="btn btn-border-teal w-100" @click="addRoom" :disabled="rooms.length >= 4">
            <i class="icon-plus ml--1" />

            <span>اضافه کردن اتاق</span>
          </button>

          <span class="text-red dis-block mt--2" v-if="error">
            {{ error }}
          </span>
        </div>
      </div>

      <div class="booking__passengers-confirm hide-in-desktop">
        <button class="btn btn-teal w-100" @click="closeTravelerList">تایید</button>
      </div>
    </div>
  </div>
</template>
